import 'jquery-match-height';
import WhitelabelLocations from './components/whitelabel/WhitelabelLocations';
import SidebarContent from './components/whitelabel/SidebarContent';
import AdminMessage from './components/whitelabel/AdminMessage';
import WhitelabelLanding from './components/whitelabel/WhitelabelLanding';
import WhitelabelIntermediary from './components/whitelabel/WhitelabelIntermediary';
import PasswordReset from './components/whitelabel/PasswordReset';
import Vue from 'vue';

$(document).on('domReady', () => {
    // Sidebar behavior on button click
    const sidebarButton = document.getElementById('sidebar-button');
    const body = document.getElementsByTagName('BODY')[0];

    if (sidebarButton) {
        sidebarButton.addEventListener('click', () => {
            body.classList.toggle('sidebar-open');
        });
    }

    // if screen is resized to bigger (>=768), remove sidebar-open class to prevent sidebar from being hidden
    $(window).resize(() => {
        if ($(window).width() >= 768) {
            $(body).removeClass('sidebar-open');
        }
    });
});

// Global components
Vue.component('whitelabel-locations', WhitelabelLocations);
Vue.component('sidebar-content', SidebarContent);
Vue.component('admin-message', AdminMessage);
Vue.component('whitelabel-landing', WhitelabelLanding);
Vue.component('whitelabel-intermediary', WhitelabelIntermediary);
Vue.component('password-reset', PasswordReset);

/**
 * Page Loader
 * If we haven't loaded a specific page we'll fake the promise
 *
 * @type {array}
 */
let LoadedPages = [];

// Space page
if (Page.is('spaceshow')) {
    LoadedPages.push(import('./pages/frontend/Space'));
}

// Space booking page
if (Page.is('spacebook')) {
    LoadedPages.push(import('./pages/frontend/Booking'));
}

export default LoadedPages;
